import { QuestId, useAvailableQuests } from '@store'

export const useIsQuestCompleted = (questSlug: QuestId) => {
  const quests = useAvailableQuests.store.quests()

  return quests.some((quest) => quest.slug === questSlug && quest.isSolved)
}
